import { MenuItem, Select, Switch } from '@mui/material'
import MapLayerOption from './MapLayerOption'

type CommonOption = { id: string; label: string; tags?: string[] }
export type MapOverlayOption = CommonOption &
  (
    | { type?: 'toggle'; checked: boolean; onChange: (checked: boolean) => void }
    | { type: 'choice'; value: string; options: { value: string; label: string }[]; onChange: (value: string) => void }
  )

export default function MapOverlayControls({ overlays }: { overlays: MapOverlayOption[] }) {
  return (
    <>
      {overlays.map(overlay => (
        <MapLayerOption
          key={overlay.id}
          label={overlay.label}
          tags={overlay.tags}
          control={labelId =>
            overlay.type === 'choice' ? (
              <Select
                labelId={labelId}
                size="small"
                value={overlay.value}
                onChange={event => overlay.onChange(event.target.value)}
                sx={{ minWidth: 132, maxWidth: '58%', fontSize: 13, '& .MuiSelect-select': { py: 0.75 } }}
              >
                {overlay.options.map(option => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            ) : (
              <Switch
                size="small"
                checked={overlay.checked}
                inputProps={{ 'aria-labelledby': labelId }}
                onChange={event => overlay.onChange(event.target.checked)}
              />
            )
          }
        />
      ))}
    </>
  )
}
